module.exports = __webpack_public_path__ + "static/media/RyanBishop-resume.f3fae361.pdf";